import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@material-ui/core";
import { useEffect, useState } from "react";
import { apiRequest } from "../../utils/api";

function SecurityQuestionsForm({ onChange, onValidityChange }) {
  const [questions, setQuestions] = useState([]);

  const [form, setForm] = useState([
    { security_question_id: "", answer: "" },
    { security_question_id: "", answer: "" },
    { security_question_id: "", answer: "" },
  ]);

  // track touched fields
  const [touched, setTouched] = useState({});

  const [errors, setErrors] = useState({});

  useEffect(() => {
    apiRequest
      .get("/api/security-questions")
      .then((res) => {
        setQuestions(res.data.data || []);
      })
      .catch(() => console.error("Failed to load questions"));
  }, []);

  const isSelected = (id, currentIndex) =>
    form.some(
      (f, i) =>
        i !== currentIndex &&
        Number(f.security_question_id) === Number(id)
    );

  // validate whenever form changes
  useEffect(() => {
    const newErrors = {};

    form.forEach((item, index) => {
      if (!item.security_question_id) {
        newErrors[`q${index}`] = true;
      }

      if (!item.answer.trim()) {
        newErrors[`a${index}`] = true;
      }
    });

    setErrors(newErrors);

    const isValid = Object.keys(newErrors).length === 0;

    if (onValidityChange) {
      onValidityChange(isValid);
    }

    if (onChange) {
      onChange(
        form.map((f) => ({
          security_question_id: Number(f.security_question_id),
          answer: f.answer.trim(),
        }))
      );
    }
  }, [form, onChange, onValidityChange]);

  const handleChange = (index, field, value) => {
    const updated = [...form];
    updated[index][field] = value;
    setForm(updated);

    // mark field as touched
    setTouched((prev) => ({
      ...prev,
      [`${field}${index}`]: true,
    }));
  };

  return (
    <div>
      {form.map((item, index) => (
        <div
          key={index}
          style={{
            marginBottom: 24,
            display: "flex",
            flexDirection: "column",
            gap: 10,
          }}
        >
          {/* QUESTION SELECT */}
          <FormControl
            variant="outlined"
            fullWidth
            error={!!touched[`security_question_id${index}`] && !!errors[`q${index}`]}
          >
            <InputLabel>{`Select Question ${index + 1}`}</InputLabel>

            <Select
              value={item.security_question_id}
              onChange={(e) =>
                handleChange(index, "security_question_id", e.target.value)
              }
              label={`Select Question ${index + 1}`}
              onBlur={() =>
                setTouched((prev) => ({
                  ...prev,
                  [`security_question_id${index}`]: true,
                }))
              }
              MenuProps={{
                autoWidth: false,
                getContentAnchorEl: null,
                anchorOrigin: {
                  vertical: "bottom",
                  horizontal: "left",
                },
                transformOrigin: {
                  vertical: "top",
                  horizontal: "left",
                },
                PaperProps: {
                  style: {
                    maxHeight: 200,
                  },
                },
              }}
            >
              {questions.map((q) => (
                <MenuItem
                  key={q.id}
                  value={q.id}
                  disabled={isSelected(q.id, index)}
                >
                  {q.question_text}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          {/* ANSWER INPUT */}
          <TextField
            variant="outlined"
            fullWidth
            placeholder="Add answer"
            value={item.answer}
            onChange={(e) =>
              handleChange(index, "answer", e.target.value)
            }
            onBlur={() =>
              setTouched((prev) => ({
                ...prev,
                [`answer${index}`]: true,
              }))
            }
            error={!!touched[`answer${index}`] && !!errors[`a${index}`]}
          />
        </div>
      ))}
    </div>
  );
}

export default SecurityQuestionsForm;